/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HotelComparisonHighlight } from './HotelComparisonHighlight';
import {
    HotelComparisonHighlightFromJSON,
    HotelComparisonHighlightFromJSONTyped,
    HotelComparisonHighlightToJSON,
    HotelComparisonHighlightToJSONTyped,
} from './HotelComparisonHighlight';

/**
 * 
 * @export
 * @interface HotelComparisonResponse
 */
export interface HotelComparisonResponse {
    /**
     * The vervotech_property_id of the recommended hotel.
     * @type {number}
     * @memberof HotelComparisonResponse
     */
    recommendedHotelId: number;
    /**
     * 2-3 sentence overview comparing the hotels for this user.
     * @type {string}
     * @memberof HotelComparisonResponse
     */
    summary: string;
    /**
     * Per-hotel personalized highlight.
     * @type {Array<HotelComparisonHighlight>}
     * @memberof HotelComparisonResponse
     */
    hotelHighlights: Array<HotelComparisonHighlight>;
    /**
     * 1-2 sentence recommendation of which hotel and why.
     * @type {string}
     * @memberof HotelComparisonResponse
     */
    recommendation: string;
}

/**
 * Check if a given object implements the HotelComparisonResponse interface.
 */
export function instanceOfHotelComparisonResponse(value: object): value is HotelComparisonResponse {
    if (!('recommendedHotelId' in value) || value['recommendedHotelId'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('hotelHighlights' in value) || value['hotelHighlights'] === undefined) return false;
    if (!('recommendation' in value) || value['recommendation'] === undefined) return false;
    return true;
}

export function HotelComparisonResponseFromJSON(json: any): HotelComparisonResponse {
    return HotelComparisonResponseFromJSONTyped(json, false);
}

export function HotelComparisonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelComparisonResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'recommendedHotelId': json['recommended_hotel_id'],
        'summary': json['summary'],
        'hotelHighlights': ((json['hotel_highlights'] as Array<any>).map(HotelComparisonHighlightFromJSON)),
        'recommendation': json['recommendation'],
    };
}

export function HotelComparisonResponseToJSON(json: any): HotelComparisonResponse {
    return HotelComparisonResponseToJSONTyped(json, false);
}

export function HotelComparisonResponseToJSONTyped(value?: HotelComparisonResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recommended_hotel_id': value['recommendedHotelId'],
        'summary': value['summary'],
        'hotel_highlights': ((value['hotelHighlights'] as Array<any>).map(HotelComparisonHighlightToJSON)),
        'recommendation': value['recommendation'],
    };
}

